import * as React from 'react';
import { Provider } from 'react-redux';
import { initReduxStore } from './app/InitReduxStore';
import { getAppStore } from './app/AppStore';
import { ConnectedAppRouter } from './app/components/Router';
import { startMicroview } from '@tableau/microview';
import { searchMetadata } from '@tableau/search-microview-communication-channels/lib/src/metadata/Metadata';

export type SearchMicroViewOwnProps = {};

export interface SearchMicroViewDispatchProps {
  readonly enterSpace: (spaceInfo: unknown) => void;
}

export type SearchMicroViewProps = SearchMicroViewOwnProps & SearchMicroViewDispatchProps;

initReduxStore();

startMicroview<SearchMicroViewProps>(searchMetadata, SearchWithGenericMicroviewPackage);

function SearchWithGenericMicroviewPackage(): JSX.Element {
  return (
    <React.Fragment>
      <Provider store={getAppStore()}>
        <ConnectedAppRouter />
      </Provider>
    </React.Fragment>
  );
}

export const SearchMicroViewHostId = 'SearchMicroViewHost';
